import { render, staticRenderFns } from "./ZBtn.vue?vue&type=template&id=47d1bab0&"
import script from "./ZBtn.vue?vue&type=script&lang=js&"
export * from "./ZBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports